import type { SxProps, Theme } from "@mui/material";

export const nonMapAreaDriverAutocompleteSx: SxProps<Theme> = {
  width: 200,
};

export const selectDriverButtonSx: SxProps<Theme> = {
  width: "250px",
};
